import AdcouponinfoComponent from '@/view/adcouponinfo'
const adCouponInfo = {
  name: 'ad-coupon-info',
  component: AdcouponinfoComponent,
  meta: {
    title: '优惠券说明'
  }
}
export default adCouponInfo
